import React from 'react';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { CircleIcon } from '@zola/zola-ui/src/components/CircleIcon';
import { WeddingWebsites } from '@zola/zola-ui/src/assets/images/icons';
import { connect } from 'react-redux';
import { hideModal } from '../../../../actions/modalActions';
import styles from './styles.module.less';

const CreateSuperlink = ({ onCancel, onConfirm }) => (
  <div className={styles.container}>
    <CircleIcon image={WeddingWebsites} size={100} variant="cream" />
    <div className={styles.header}>Create a superlink for *free*</div>
    <div className={styles.content}>
      A wedding superlink is the easiest way to collect information about your guests. We&lsquo;ll
      make this simple and fun, promise! We&lsquo;ve saved your save the date to your drafts, in
      case you want to take a look around.
    </div>
    <div className={styles.buttonContainer}>
      <ButtonV2 variant="secondary" onClick={onCancel}>
        Maybe Later
      </ButtonV2>
      <ButtonV2 onClick={onConfirm}>Get Started</ButtonV2>
    </div>
  </div>
);

const mapDispatchToProps = dispatch => ({
  onConfirm: () => {
    dispatch(hideModal());
    window.open('/wedding/manage/guests/collection-link/configure', '_blank');
  },
  onCancel: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(CreateSuperlink);
